export default "__VITE_ASSET__31ce0cb3__"